import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "line-config" }
const _hoisted_2 = { class: "line-panel" }
const _hoisted_3 = { class: "panel-header" }
const _hoisted_4 = { class: "header-ops" }
const _hoisted_5 = { class: "line-list" }
const _hoisted_6 = {
  key: 0,
  class: "line-item is-current"
}
const _hoisted_7 = { class: "current-info" }
const _hoisted_8 = { class: "current-name-row" }
const _hoisted_9 = { class: "current-name" }
const _hoisted_10 = {
  key: 0,
  class: "current-host"
}
const _hoisted_11 = { class: "current-stats" }
const _hoisted_12 = {
  key: 0,
  class: "stat-chip"
}
const _hoisted_13 = {
  key: 0,
  class: "lat-fail"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 1,
  class: "stat-chip"
}
const _hoisted_16 = {
  key: 0,
  class: "lat-fail"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 2,
  class: "stat-chip is-empty"
}
const _hoisted_19 = { class: "current-actions" }
const _hoisted_20 = {
  key: 0,
  class: "manage-group"
}
const _hoisted_21 = { class: "line-body" }
const _hoisted_22 = { class: "line-name-row" }
const _hoisted_23 = { class: "line-name" }
const _hoisted_24 = ["title"]
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  key: 2,
  class: "lat-fail"
}
const _hoisted_27 = { class: "line-meta" }
const _hoisted_28 = ["title"]
const _hoisted_29 = ["title"]
const _hoisted_30 = ["title"]
const _hoisted_31 = { class: "line-actions" }
const _hoisted_32 = {
  key: 0,
  class: "manage-group"
}
const _hoisted_33 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_34 = { class: "modal-form" }
const _hoisted_35 = { class: "form-item" }
const _hoisted_36 = { class: "form-item" }
const _hoisted_37 = { class: "form-item" }
const _hoisted_38 = {
  key: 0,
  class: "form-item"
}
const _hoisted_39 = { class: "lat-history" }
const _hoisted_40 = { class: "lat-history-list" }
const _hoisted_41 = ["title"]
const _hoisted_42 = { class: "lh-time-full" }
const _hoisted_43 = { class: "lh-time-short" }
const _hoisted_44 = {
  class: "lh-metric",
  "data-label": "指标"
}
const _hoisted_45 = { class: "lh-sub" }
const _hoisted_46 = ["title"]
const _hoisted_47 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_48 = {
  key: 1,
  class: "empty-tip"
}
const _hoisted_49 = { class: "lat-history-footer" }
const _hoisted_50 = { class: "lat-total" }

import { ref, computed, onMounted, inject, type Ref } from 'vue';
import {
  NButton,
  NInput,
  NSwitch,
  NModal,
  NPopconfirm,
  NDrawer,
  NDrawerContent,
  NPagination,
} from 'naive-ui';
import Tools from '@/ts/Tools';

// ========== 线路列表 ==========
interface LineItem {
  id?: number;
  name: string;
  host: string;
  /** 稳定性测速下载路径（可选，如 /test10m.bin；为空用 /） */
  test_path?: string;
  sort_order: number;
  is_current: number;
  create_time?: number;
  update_time?: number;
}

interface LineLatency {
  id?: number;
  line_id?: number;
  name: string;
  host: string;
  kind: string;
  latency_ms?: number;
  ok: number;
  error: string;
  source: string;
  // 稳定性测速字段
  avg_kbps?: number;
  min_kbps?: number;
  max_kbps?: number;
  stdev_kbps?: number;
  slow_ratio?: number;
  bytes?: number;
  duration_ms?: number;
  idle_rtt_ms?: number;
  loaded_rtt_ms?: number;
  create_time: number;
}

/** 单条/全量延迟测速接口的即时返回 */
interface LineLatencyProbe {
  id: number;
  name: string;
  host: string;
  latency: number;
  ok: boolean;
  error: string;
  at: number;
}

/** 稳定性测速接口的即时返回 */
interface LineSpeedProbe {
  id: number;
  name: string;
  host: string;
  url: string;
  latency: number;
  avgKbps: number;
  minKbps: number;
  maxKbps: number;
  stdevKbps: number;
  slowRatio: number;
  bytes: number;
  durationMs: number;
  idleRttMs?: number | null;
  loadedRttMs?: number | null;
  insufficient: boolean;
  ok: boolean;
  error: string;
  at: number;
}

/** 每条线路最近一次「延迟测速」结果：lineId -> 记录 */
interface LineItemView extends LineItem {
  latency: LineLatency | null;
  speed: LineLatency | null;
}

/** 其他线路 + 各自的最近测速结果（模板里直接用 item.latency / item.speed） */

export default /*@__PURE__*/_defineComponent({
  __name: 'LineConfigManage',
  setup(__props) {

const lineList = ref<LineItem[]>([]);

// 调试模式：Ctrl+Shift+D 统一切换线路地址显示
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));

// 当前使用的线路
const currentLine = computed(() =>
  lineList.value.find((item) => item.is_current == 1) ?? null
);

// 其他线路（排除当前使用）
const otherLines = computed(() =>
  lineList.value.filter((item) => item.is_current != 1)
);

// ========== 测速 ==========
/** 一条测速记录（后端 line_latency_history） */
const latencyMap = ref<Record<number, LineLatency>>({});
/** 每条线路最近一次「稳定性测速」结果：lineId -> 记录 */
const speedMap = ref<Record<number, LineLatency>>({});
/** 正在延迟测速的线路ID（按钮 loading） */
const testingId = ref<number | null>(null);
/** 正在稳定性测速的线路ID（按钮 loading） */
const speedTestingId = ref<number | null>(null);
/** 全量测速进行中 */
const testingAll = ref(false);

const currentLatency = computed<LineLatency | null>(() => {
  const id = currentLine.value?.id;
  return id == null ? null : latencyMap.value[id] ?? null;
});

const currentSpeed = computed<LineLatency | null>(() => {
  const id = currentLine.value?.id;
  return id == null ? null : speedMap.value[id] ?? null;
});

const otherLineViews = computed<LineItemView[]>(() =>
  otherLines.value.map((line) => ({ ...line, latency: latencyOf(line), speed: speedOf(line) }))
);

function latencyOf(item: LineItem): LineLatency | null {
  const id = item.id;
  return id == null ? null : latencyMap.value[id] ?? null;
}

function speedOf(item: LineItem): LineLatency | null {
  const id = item.id;
  return id == null ? null : speedMap.value[id] ?? null;
}

/** 延迟配色：<=150 绿 / <=350 黄 / 更差或失败 红 */
function latencyClass(record: LineLatency): string {
  if (!record || !record.ok) return 'lat-bad';
  const ms = Number(record.latency_ms);
  if (!Number.isFinite(ms)) return '';
  if (ms <= 150) return 'lat-good';
  if (ms <= 350) return 'lat-warn';
  return 'lat-bad';
}

function latencyTitle(record: LineLatency): string {
  if (!record) return '';
  const at = formatTime(record.create_time);
  return record.ok
    ? `最近一次测速 ${at}：${record.latency_ms} ms`
    : `最近一次测速 ${at} 失败：${record.error || '-'}`;
}

/** 一条记录的说明：失败原因 / 稳定测速掉速比例 / 正常的记录给「正常」 */
function historyNote(r: LineLatency): string {
  if (r.error) return r.error;
  if (r.kind === 'speed' && r.avg_kbps != null) return `掉速${r.slow_ratio ?? 0}%`;
  return r.ok ? '正常' : '-';
}

/** KB/s 友好显示：<1024 显示 KB/s，否则 MB/s */
function fmtKbps(kbps?: number): string {
  if (kbps == null || !Number.isFinite(kbps)) return '-';
  if (kbps >= 1024) return `${(kbps / 1024).toFixed(2)} MB/s`;
  return `${Math.round(kbps)} KB/s`;
}

/** 稳定性测速配色：按均值速度分级（与视频码率直觉一致） */
function speedClass(record: LineLatency): string {
  if (!record || !record.ok) return 'lat-bad';
  const k = Number(record.avg_kbps);
  if (!Number.isFinite(k)) return '';
  if (k >= 4096) return 'lat-good'; // >= 4 MB/s
  if (k >= 1024) return 'lat-warn'; // 1~4 MB/s
  return 'lat-bad'; // < 1 MB/s
}

function speedTitle(record: LineLatency): string {
  if (!record) return '';
  const at = formatTime(record.create_time);
  if (!record.ok) return `最近一次稳定测速 ${at} 失败：${record.error || '-'}`;
  const jitter = record.loaded_rtt_ms != null && record.idle_rtt_ms != null
    ? `；满载 RTT ${record.loaded_rtt_ms}ms（空闲 ${record.idle_rtt_ms}ms，排队 +${record.loaded_rtt_ms - record.idle_rtt_ms}ms）`
    : '';
  return `最近一次稳定测速 ${at}：均速 ${fmtKbps(record.avg_kbps)}，抖动±${record.stdev_kbps ?? '-'}KB/s，掉速 ${record.slow_ratio ?? 0}%${jitter}`;
}

/** 把测速接口的返回值套成列表展示用的记录结构 */
function applyProbe(item: LineItem, probe: LineLatencyProbe, source: string) {
  const id = item.id;
  if (id == null) return;
  latencyMap.value = {
    ...latencyMap.value,
    [id]: {
      line_id: id,
      name: item.name,
      host: item.host,
      latency_ms: probe.latency,
      ok: probe.ok ? 1 : 0,
      error: probe.error || '',
      source,
      create_time: probe.at || Math.floor(Date.now() / 1000)
    }
  };
}

/** 拉取每条线路最近一次「延迟测速」与「稳定性测速」结果 */
async function loadLatencyLatest() {
  try {
    const resp = await Tools.FetchGetAsync<{
      latency: LineLatency[];
      speed: LineLatency[];
    }>('line/latency-latest', {});
    // 不弹错：测速表还没建时，不该影响线路列表本身的展示
    if (resp.CheckIsOk(false) && resp.Data) {
      const lat: Record<number, LineLatency> = {};
      for (const row of resp.Data.latency ?? []) {
        if (row.line_id != null) lat[row.line_id] = row;
      }
      latencyMap.value = lat;
      const spd: Record<number, LineLatency> = {};
      for (const row of resp.Data.speed ?? []) {
        if (row.line_id != null) spd[row.line_id] = row;
      }
      speedMap.value = spd;
    }
  } catch {
    // 忽略
  }
}

/** 把稳定性测速接口的返回值套成列表展示用的记录结构 */
function applySpeed(item: LineItem, probe: LineSpeedProbe) {
  const id = item.id;
  if (id == null) return;
  speedMap.value = {
    ...speedMap.value,
    [id]: {
      line_id: id,
      name: item.name,
      host: item.host,
      kind: 'speed',
      ok: probe.ok ? 1 : 0,
      error: probe.error || '',
      source: 'manual',
      avg_kbps: probe.avgKbps,
      min_kbps: probe.minKbps,
      max_kbps: probe.maxKbps,
      stdev_kbps: probe.stdevKbps,
      slow_ratio: probe.slowRatio,
      bytes: probe.bytes,
      duration_ms: probe.durationMs,
      idle_rtt_ms: probe.idleRttMs ?? undefined,
      loaded_rtt_ms: probe.loadedRttMs ?? undefined,
      create_time: probe.at || Math.floor(Date.now() / 1000)
    }
  };
}

/** 单条线路立即测速 */
async function handleTestLine(item: LineItem) {
  if (item.id == null || testingId.value != null) return;
  testingId.value = item.id;
  try {
    const resp = await Tools.FetchAsync<LineLatencyProbe>('line/test', { id: item.id }, 'POST');
    if (resp.CheckIsOk() && resp.Data) {
      applyProbe(item, resp.Data, 'manual');
    }
  } finally {
    testingId.value = null;
  }
}

/** 单条线路稳定性测速（持续下载 6 秒采样带宽与抖动） */
async function handleSpeedTest(item: LineItem) {
  if (item.id == null || speedTestingId.value != null) return;
  speedTestingId.value = item.id;
  try {
    const resp = await Tools.FetchAsync<LineSpeedProbe>('line/speedtest', { id: item.id }, 'POST');
    if (resp.CheckIsOk() && resp.Data) {
      applySpeed(item, resp.Data);
      if (resp.Data.insufficient) {
        Tools.AlertError(
          `下载量不足（${Math.round(resp.Data.bytes / 1024)} KB），请给该线路配置一个 ≥10MB 的测速路径（编辑里填写）`
        );
      } else if (!resp.Data.ok) {
        Tools.AlertError(resp.Data.error || '稳定性测速失败');
      } else {
        const slow = resp.Data.slowRatio > 30;
        Tools.AlertSuccess(
          slow
            ? `稳定测速完成：均速 ${fmtKbps(resp.Data.avgKbps)}，但 ${resp.Data.slowRatio.toFixed(0)}% 采样点掉速明显，视频可能卡`
            : `稳定测速完成：均速 ${fmtKbps(resp.Data.avgKbps)}`
        );
      }
    }
  } finally {
    speedTestingId.value = null;
  }
}

/** 全量测速：所有线路各测一次延迟 */
async function handleTestAll() {
  if (testingAll.value || lineList.value.length === 0) return;
  testingAll.value = true;
  try {
    const resp = await Tools.FetchAsync<{ total: number; at: number; list: LineLatencyProbe[] }>(
      'line/test-all',
      {},
      'POST'
    );
    if (resp.CheckIsOk() && resp.Data) {
      for (const probe of resp.Data.list ?? []) {
        const line = lineList.value.find((l) => l.id === probe.id);
        if (line) applyProbe(line, probe, 'all');
      }
      const failed = (resp.Data.list ?? []).filter((p) => !p.ok).length;
      Tools.AlertSuccess(
        failed === 0 ? `全量测速完成（${resp.Data.total} 条线路）` : `全量测速完成，${failed} 条失败`
      );
    }
  } finally {
    testingAll.value = false;
  }
}

// ========== 测速记录 ==========
const showLatencyHistory = ref(false);
const latencyHistoryLine = ref<LineItem | null>(null);
const latencyHistoryList = ref<LineLatency[]>([]);
const latencyHistoryTotal = ref(0);
const latencyHistoryPage = ref(1);
const latencyHistoryPageSize = ref(20);
const latencyHistoryLoading = ref(false);

async function openLatencyHistory(item: LineItem) {
  latencyHistoryLine.value = item;
  latencyHistoryList.value = [];
  latencyHistoryTotal.value = 0;
  latencyHistoryPage.value = 1;
  showLatencyHistory.value = true;
  await loadLatencyHistory(1, latencyHistoryPageSize.value);
}

async function loadLatencyHistory(page: number = 1, pageSize: number = latencyHistoryPageSize.value) {
  const lineId = latencyHistoryLine.value?.id;
  if (lineId == null) return;
  latencyHistoryLoading.value = true;
  try {
    const resp = await Tools.FetchGetAsync<{
      total: number;
      page: number;
      page_size: number;
      list: LineLatency[];
    }>('line/latency-history', { lineId, page, pageSize });
    if (resp.CheckIsOk() && resp.Data) {
      latencyHistoryList.value = resp.Data.list ?? [];
      latencyHistoryTotal.value = resp.Data.total ?? 0;
      latencyHistoryPage.value = resp.Data.page ?? page;
      latencyHistoryPageSize.value = resp.Data.page_size ?? pageSize;
    }
  } finally {
    latencyHistoryLoading.value = false;
  }
}

function handleLatencyHistoryPage(page: number) {
  void loadLatencyHistory(page, latencyHistoryPageSize.value);
}

function handleLatencyHistoryPageSize(pageSize: number) {
  void loadLatencyHistory(1, pageSize);
}

/** Unix 秒 → yyyy-MM-dd HH:mm:ss */
function formatTime(unix?: number | null): string {
  if (!unix) return '-';
  const d = new Date(unix * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** Unix 秒 → MM-DD HH:mm（手机窄屏用，去掉年份和秒） */
function formatTimeShort(unix?: number | null): string {
  if (!unix) return '-';
  const d = new Date(unix * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// ========== 弹窗 ==========
const showModal = ref(false);
const editingId = ref<number | null>(null);
const submitting = ref(false);

const modalTitle = ref('新增线路');
const form = ref({
  name: '',
  host: '',
  testPath: '',
  sortOrder: 0,
  isCurrent: false,
});

// ========== 加载线路列表 ==========
async function loadLineList() {
  Tools.FetchGetAsync<{ total: number; list: LineItem[] }>(
    'line/list', {}
  ).then((resp) => {
    if (resp.CheckIsOk() && resp.Data) {
      lineList.value = resp.Data.list ?? [];
    }
  });
}

// ========== 打开新增弹窗 ==========
function openAddModal() {
  editingId.value = null;
  modalTitle.value = '新增线路';
  form.value = { name: '', host: '', testPath: '', sortOrder: 0, isCurrent: false };
  showModal.value = true;
}

// ========== 打开编辑弹窗 ==========
function openEditModal(item: LineItem) {
  editingId.value = item.id!;
  modalTitle.value = '编辑线路';
  form.value = {
    name: item.name,
    host: item.host,
    testPath: item.test_path ?? '',
    sortOrder: item.sort_order,
    isCurrent: false, // 编辑不传此字段，占位用
  };
  showModal.value = true;
}

// ========== 提交表单 ==========
async function handleSubmit() {
  // 防重复提交
  if (submitting.value) return false;
  submitting.value = true;

  try {
    // 去除首尾空格
    form.value.name = form.value.name.trim();
    form.value.host = form.value.host.trim();

    if (!form.value.name) {
      Tools.AlertError('线路名称不能为空');
      return false;
    }
    if (/\s/.test(form.value.name)) {
      Tools.AlertError('线路名称不能包含空格');
      return false;
    }
    if (!form.value.host) {
      Tools.AlertError('线路域名不能为空');
      return false;
    }
    if (/\s/.test(form.value.host)) {
      Tools.AlertError('线路域名不能包含空格');
      return false;
    }

    if (editingId.value) {
      // 编辑
      const resp = await Tools.FetchAsync<{ id: number }>(
        'line/update',
        {
          id: editingId.value,
          name: form.value.name,
          host: form.value.host,
          testPath: form.value.testPath,
          sortOrder: form.value.sortOrder,
        },
        'POST'
      );
      if (resp.CheckIsOk()) {
        Tools.AlertSuccess('更新成功');
        showModal.value = false;
        refreshAll();
      }
    } else {
      // 新增
      const resp = await Tools.FetchAsync<{ name: string; host: string }>(
        'line/create',
        {
          name: form.value.name,
          host: form.value.host,
          testPath: form.value.testPath,
          sortOrder: form.value.sortOrder,
          isCurrent: form.value.isCurrent ? 1 : 0,
        },
        'POST'
      );
      if (resp.CheckIsOk()) {
        Tools.AlertSuccess('新增成功');
        showModal.value = false;
        refreshAll();
      }
    }
  } finally {
    submitting.value = false;
  }
}

// ========== 删除线路 ==========
async function handleDeleteLine(id: number) {
  Tools.FetchGetAsync<{ id: number; wasCurrent: boolean }>(
    'line/delete', { id }
  ).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('删除成功');
      refreshAll();
    }
  });
}

// ========== 选择当前线路 ==========
async function handleSelectLine(item: LineItem) {
  Tools.FetchAsync<{ id: number; name: string; host: string }>(
    'line/select',
    { id: item.id! },
    'POST'
  ).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess(`已切换到线路: ${item.name}`);
      refreshAll();
    }
  });
}

// ========== 刷新 ==========
function refreshAll() {
  void loadLineList();
  void loadLatencyLatest();
}

onMounted(() => {
  refreshAll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "panel-title" }, "线路管理", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(NButton), {
            size: "large",
            type: "success",
            ghost: "",
            class: "add-btn",
            loading: testingAll.value,
            disabled: lineList.value.length === 0,
            onClick: handleTestAll
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(testingAll.value ? '测速中' : '全量测速'), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          (_unref(debugMode))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 0,
                type: "primary",
                size: "large",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddModal())),
                class: "add-btn"
              }, {
                icon: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "5",
                      x2: "12",
                      y2: "19"
                    }),
                    _createElementVNode("line", {
                      x1: "5",
                      y1: "12",
                      x2: "19",
                      y2: "12"
                    })
                  ], -1)
                ])),
                default: _withCtx(() => [
                  _cache[13] || (_cache[13] = _createTextVNode(" 新增 "))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (currentLine.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "current-badge" }, [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "12",
                      height: "12",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "3",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                    ]),
                    _createTextVNode(" 当前使用 ")
                  ], -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(currentLine.value.name), 1)
                ]),
                (_unref(debugMode))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(currentLine.value.host), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  (currentLatency.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "stat-label" }, "延迟", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["stat-val", latencyClass(currentLatency.value)])
                        }, _toDisplayString(currentLatency.value.latency_ms) + " ms", 3),
                        (!currentLatency.value.ok)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "失败"))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: "stat-time",
                          title: formatTime(currentLatency.value.create_time)
                        }, _toDisplayString(formatTimeShort(currentLatency.value.create_time)), 9, _hoisted_14)
                      ]))
                    : _createCommentVNode("", true),
                  (currentSpeed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "stat-label" }, "速率", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["stat-val", speedClass(currentSpeed.value)])
                        }, _toDisplayString(fmtKbps(currentSpeed.value.avg_kbps)), 3),
                        (!currentSpeed.value.ok)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "失败"))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: "stat-time",
                          title: formatTime(currentSpeed.value.create_time)
                        }, _toDisplayString(formatTimeShort(currentSpeed.value.create_time)), 9, _hoisted_17)
                      ]))
                    : _createCommentVNode("", true),
                  (!currentLatency.value && !currentSpeed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[18] || (_cache[18] = [
                        _createElementVNode("span", { class: "stat-label" }, "暂无测速记录", -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(NButton), {
                  size: "medium",
                  ghost: "",
                  loading: testingId.value === currentLine.value.id,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleTestLine(currentLine.value))),
                  class: "action-btn"
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("测速")
                  ])),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_unref(NButton), {
                  size: "medium",
                  ghost: "",
                  loading: speedTestingId.value === currentLine.value.id,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSpeedTest(currentLine.value))),
                  class: "action-btn"
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("稳定测速")
                  ])),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_unref(NButton), {
                  size: "medium",
                  ghost: "",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openLatencyHistory(currentLine.value))),
                  class: "action-btn"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("记录")
                  ])),
                  _: 1
                }),
                (_unref(debugMode))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_unref(NButton), {
                        size: "medium",
                        quaternary: "",
                        circle: "",
                        title: "修改",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (openEditModal(currentLine.value))),
                        class: "action-btn icon-btn"
                      }, {
                        icon: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "15",
                            height: "15",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
                          ], -1)
                        ])),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "current-mask" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherLineViews.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "line-item",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(item.name), 1),
                (item.latency)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["metric", latencyClass(item.latency)]),
                      title: latencyTitle(item.latency)
                    }, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "metric-label" }, "延迟", -1)),
                      _createTextVNode(_toDisplayString(item.latency.latency_ms) + " ms ", 1)
                    ], 10, _hoisted_24))
                  : _createCommentVNode("", true),
                (item.speed)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["metric", speedClass(item.speed)]),
                      title: speedTitle(item.speed)
                    }, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "metric-label" }, "速率", -1)),
                      _createTextVNode(_toDisplayString(fmtKbps(item.speed.avg_kbps)), 1)
                    ], 10, _hoisted_25))
                  : _createCommentVNode("", true),
                ((item.latency && !item.latency.ok) || (item.speed && !item.speed.ok))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "失败"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                (_unref(debugMode))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "line-host",
                      title: item.host
                    }, _toDisplayString(item.host), 9, _hoisted_28))
                  : _createCommentVNode("", true),
                (item.latency)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "line-time",
                      title: formatTime(item.latency.create_time)
                    }, " 测速 " + _toDisplayString(formatTimeShort(item.latency.create_time)), 9, _hoisted_29))
                  : _createCommentVNode("", true),
                (item.speed)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: "line-time",
                      title: formatTime(item.speed.create_time)
                    }, " 稳定性 " + _toDisplayString(formatTimeShort(item.speed.create_time)), 9, _hoisted_30))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_unref(NButton), {
                size: "medium",
                ghost: "",
                loading: testingId.value === item.id,
                onClick: ($event: any) => (handleTestLine(item)),
                class: "action-btn"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode("测速")
                ])),
                _: 2
              }, 1032, ["loading", "onClick"]),
              _createVNode(_unref(NButton), {
                size: "medium",
                ghost: "",
                loading: speedTestingId.value === item.id,
                onClick: ($event: any) => (handleSpeedTest(item)),
                class: "action-btn"
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("稳定测速")
                ])),
                _: 2
              }, 1032, ["loading", "onClick"]),
              _createVNode(_unref(NButton), {
                size: "medium",
                ghost: "",
                onClick: ($event: any) => (openLatencyHistory(item)),
                class: "action-btn"
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode("记录")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_unref(NButton), {
                size: "medium",
                type: "primary",
                onClick: ($event: any) => (handleSelectLine(item)),
                class: "action-btn"
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [
                  _createTextVNode(" 选用 ")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (_unref(debugMode))
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_unref(NButton), {
                      size: "medium",
                      quaternary: "",
                      circle: "",
                      title: "编辑",
                      onClick: ($event: any) => (openEditModal(item)),
                      class: "action-btn icon-btn"
                    }, {
                      icon: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" })
                        ], -1)
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(NPopconfirm), {
                      onPositiveClick: ($event: any) => (handleDeleteLine(item.id!))
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(_unref(NButton), {
                          size: "medium",
                          quaternary: "",
                          circle: "",
                          title: "删除",
                          class: "action-btn icon-btn"
                        }, {
                          icon: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("polyline", { points: "3 6 5 6 21 6" }),
                              _createElementVNode("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" })
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" 确定删除线路 \"" + _toDisplayString(item.name) + "\" 吗？ ", 1)
                      ]),
                      _: 2
                    }, 1032, ["onPositiveClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        (lineList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, "暂无线路配置，点击「新增」开始添加"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: showModal.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showModal).value = $event)),
      preset: "dialog",
      title: modalTitle.value,
      "positive-text": "确认",
      "negative-text": "取消",
      loading: submitting.value,
      onPositiveClick: handleSubmit,
      onNegativeClick: _cache[10] || (_cache[10] = ($event: any) => {showModal.value = false; submitting.value = false})
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "form-label" }, "线路名称", -1)),
            _createVNode(_unref(NInput), {
              value: form.value.name,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.name) = $event)),
              placeholder: "如：加速、直连、本地",
              size: "large"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "form-label" }, "线路域名", -1)),
            _createVNode(_unref(NInput), {
              value: form.value.host,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.host) = $event)),
              placeholder: "如：api.example.com",
              size: "large"
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "form-label" }, "测速路径", -1)),
            _createVNode(_unref(NInput), {
              value: form.value.testPath,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.testPath) = $event)),
              placeholder: "稳定性测速下载文件，如 /test10m.bin；留空用 /",
              size: "large"
            }, null, 8, ["value"])
          ]),
          (!editingId.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "form-label" }, "设为当前线路", -1)),
                _createVNode(_unref(NSwitch), {
                  value: form.value.isCurrent,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.isCurrent) = $event)),
                  size: "large"
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show", "title", "loading"]),
    _createVNode(_unref(NDrawer), {
      show: showLatencyHistory.value,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showLatencyHistory).value = $event)),
      placement: "right",
      width: "min(640px, 100vw)"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NDrawerContent), {
          title: `测速记录 · ${latencyHistoryLine.value?.name || ''}`,
          closable: "",
          "body-content-style": { height: '100%', boxSizing: 'border-box', display: 'flex', flexDirection: 'column' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_39, [
              _cache[36] || (_cache[36] = _createElementVNode("div", { class: "lat-history-cols" }, [
                _createElementVNode("span", null, "时间"),
                _createElementVNode("span", null, "类型"),
                _createElementVNode("span", null, "指标"),
                _createElementVNode("span", null, "结果"),
                _createElementVNode("span", null, "说明")
              ], -1)),
              _createElementVNode("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latencyHistoryList.value, (r) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "lat-history-item",
                    key: r.id
                  }, [
                    _createElementVNode("span", {
                      class: "lh-time",
                      "data-label": "时间",
                      title: formatTime(r.create_time)
                    }, [
                      _createElementVNode("span", _hoisted_42, _toDisplayString(formatTime(r.create_time)), 1),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(formatTimeShort(r.create_time)), 1)
                    ], 8, _hoisted_41),
                    _createElementVNode("span", {
                      class: _normalizeClass(["lh-kind", r.kind === 'speed' ? 'kind-speed' : 'kind-lat']),
                      "data-label": "类型"
                    }, _toDisplayString(r.kind === 'speed' ? '稳定' : '延迟'), 3),
                    _createElementVNode("span", _hoisted_44, [
                      (r.kind === 'speed')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["lh-speed", speedClass(r)])
                            }, _toDisplayString(fmtKbps(r.avg_kbps)), 3),
                            _createElementVNode("span", _hoisted_45, "抖动±" + _toDisplayString(r.stdev_kbps ?? '-'), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["lh-lat", latencyClass(r)])
                          }, _toDisplayString(r.latency_ms) + " ms", 3))
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["lh-ok", { bad: !r.ok }]),
                      "data-label": "结果"
                    }, _toDisplayString(r.ok ? '成功' : '失败'), 3),
                    _createElementVNode("span", {
                      class: "lh-error",
                      "data-label": "说明",
                      title: r.error || ''
                    }, _toDisplayString(historyNote(r)), 9, _hoisted_46)
                  ]))
                }), 128)),
                (latencyHistoryLoading.value && latencyHistoryList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, "加载中…"))
                  : (latencyHistoryList.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, "暂无测速记录"))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("span", _hoisted_50, "共 " + _toDisplayString(latencyHistoryTotal.value) + " 条", 1),
                _createVNode(_unref(NPagination), {
                  page: latencyHistoryPage.value,
                  "page-size": latencyHistoryPageSize.value,
                  "item-count": latencyHistoryTotal.value,
                  "page-sizes": [20, 50, 100],
                  "show-size-picker": "",
                  size: "small",
                  "onUpdate:page": handleLatencyHistoryPage,
                  "onUpdate:pageSize": handleLatencyHistoryPageSize
                }, null, 8, ["page", "page-size", "item-count"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})